module.exports = __webpack_public_path__ + "static/media/focus.d90edee7.svg";